export const parseAmount = (
  v: string | number | null | undefined,
): number | null => {
  if (v == null || v === '') return null
  const n = typeof v === 'string' ? parseFloat(v) : v
  return Number.isNaN(n) ? null : n
}

export const formatCurrency = (
  v: string | number | null | undefined,
  decimals = 2,
): string => {
  const n = parseAmount(v)
  if (n == null) return '—'
  return n.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })
}

export const formatNegative = (
  v: string | number | null | undefined,
  decimals = 2,
): string => {
  const n = parseAmount(v)
  if (n == null) return '—'
  return formatCurrency(n === 0 ? 0 : -Math.abs(n), decimals)
}

export const formatPercent = (v: number | null | undefined): string => {
  if (v == null) return '—'
  return `${v.toFixed(2)}%`
}

export const formatDate = (iso: string | null | undefined): string => {
  if (!iso) return '—'
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return '—'
  if (d.getUTCFullYear() === 1970) return '—'
  const mm = String(d.getUTCMonth() + 1).padStart(2, '0')
  const dd = String(d.getUTCDate()).padStart(2, '0')
  const yyyy = d.getUTCFullYear()
  return `${mm}/${dd}/${yyyy}`
}

export function convert24HourTo12Hour(timestamp: string) {
  const [hour, minute] = timestamp.split(':')
  return `${parseInt(hour) % 12 || 12}:${minute} ${parseInt(hour) < 12 ? 'AM' : 'PM'}`
}
